"use client";

import { SanitizedHTML, useHeader } from "@highway/design-system";
import { useScreenSize } from "@highway/hwy-design-system";
import { Fade, Stack, Typography, useTheme } from "@mui/material";
import FeedbackButton from "../../members/newsletter/components/FeedbackButton";
import { LOCard, LOTag } from "../../members/newsletter/components/LOCard";
import TableOfContents from "../../members/newsletter/components/TableOfContents";
import ArticlePreface from "../../../components/global-features/ArticlePreface/ArticlePreface";
import { ArticleTitle } from "../../../components/global-features/ArticleTitle";
import { Divider } from "../../../components/global-features/Divider/Divider";
import "../../../components/global-features/ViewedArticle/ViewedArticle.css";
import { useArticle } from "../../../hooks/useArticle/useArticle";
import insertDownloadButtons from "../../members/newsletter/utils/insertDownloadButtons";

const NewsletterLiveShare = () => {
    const theme = useTheme();
    const { viewedArticle, disclaimer } = useArticle({ baseRoute: "newsletter", getDisclaimer: true });
    const { isXS } = useScreenSize();
    const { header } = useHeader();
    const pages = viewedArticle?.body ? viewedArticle.body.split("<h3>") : null;

    return (
        <>
            <title>Weekly Newsletter</title>
            <Fade in={!!viewedArticle && !!pages}>
                <Stack
                    spacing={3}
                    sx={{
                        backgroundColor: (theme) => theme.palette.extendedGrey2.main,
                        padding: isXS ? "24px 16px 80px 16px" : "56px 432px 0 80px",
                    }}
                >
                    <ArticleTitle
                        title={viewedArticle?.title || ""}
                        subtitle={viewedArticle?.subtitle || ""}
                    />
                    <ArticlePreface viewedArticle={viewedArticle} />
                    {isXS && (
                        <>
                            <LOTag header={header} />
                            <Divider />
                        </>
                    )}
                    {pages?.slice(1).map((pageContent, index) => (
                        <Typography
                            key={index}
                            component="div"
                            sx={{ img: { maxWidth: "100%" } }}
                            className="article-body"
                        >
                            <SanitizedHTML html={insertDownloadButtons("<h3>" + pageContent, theme)} />
                        </Typography>
                    ))}
                    <Stack spacing={4} alignItems="center">
                        <FeedbackButton />
                        <Divider />
                    </Stack>
                    <TableOfContents />
                    {isXS && (
                        <div style={{ paddingTop: "24px" }}>
                            <LOCard />
                        </div>
                    )}
                    <Typography>{disclaimer}</Typography>
                </Stack>
            </Fade>
        </>
    );
};

export default NewsletterLiveShare;
